"use client";

import React from "react";
import { Box, ThemeProvider } from "@mui/material";

import App from "./App";
import emailBuilderTheme from "./theme";
import "./EmailBuilderEditor.scss";

interface EmailBuilderEditorProps {
  headerSlot?: React.ReactNode;
}

export default function EmailBuilderEditor({ headerSlot }: EmailBuilderEditorProps) {
  return (
    <ThemeProvider theme={emailBuilderTheme}>
      <Box
        className="email-builder-root"
        sx={{
          position: "relative",
          width: "100%",
          height: "100%",
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          bgcolor: "background.default",
          isolation: "isolate",
        }}
      >
        <App headerSlot={headerSlot} />
      </Box>
    </ThemeProvider>
  );
}
